import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles, Crown, ArrowRight, Star } from 'lucide-react';
const benefits = ['Protocolos de crisis en tiempo real', 'Tracker de progreso 30 días', 'Sistema premium de sueño profundo', 'Reset completo del sistema nervioso', 'Implementación guiada avanzada'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0
  }
};
export function UpsellSection() {
  return <section className="py-24 bg-navy relative overflow-hidden" data-id="element-163">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-164">
        <div className="absolute top-10 left-10 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-165"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-166"></div>
        <Star className="absolute top-20 right-1/4 text-gold/20" size={32} data-id="element-167" />
        <Star className="absolute bottom-32 left-1/4 text-gold/20" size={24} data-id="element-168" />
        <Sparkles className="absolute top-1/2 right-10 text-gold/20" size={48} data-id="element-169" />
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-170">
        <motion.div className="bg-navy-dark/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 border-2 border-gold/40 shadow-[0_0_50px_rgba(201,169,110,0.15)] relative" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-171">
          {/* Pulsing border effect */}
          <div className="absolute inset-0 rounded-3xl border-2 border-gold/50 animate-pulse pointer-events-none" data-id="element-172"></div>

          {/* Badge */}
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-gold-dark via-gold to-gold-dark text-navy-dark px-6 py-2 rounded-full font-bold text-sm tracking-widest flex items-center gap-2 shadow-lg border border-gold-light/50" data-id="element-173">
            <Crown size={16} data-id="element-174" />
            UPGRADE EXCLUSIVO
            <Crown size={16} data-id="element-175" />
          </div>

          <div className="text-center mb-10 mt-4 relative z-10" data-id="element-176">
            <h2 className="text-3xl md:text-5xl font-serif text-white mb-4 leading-tight" data-id="element-177">
              ¿Querés una implementación{' '}
              <span className="text-gold italic" data-id="element-178">más profunda?</span>
            </h2>
            <p className="text-beige-light/80 text-lg max-w-2xl mx-auto" data-id="element-179">
              El sistema avanzado de 30 días para quienes están listos para ir
              un paso más allá y transformar su vida por completo.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center mb-10" data-id="element-180">
            {/* Image Column */}
            <div className="relative flex justify-center order-2 md:order-1" data-id="element-181">
              {/* Glow behind image */}
              <div className="absolute inset-0 bg-gold/20 blur-2xl rounded-full scale-75" data-id="element-182"></div>

              <motion.img src="https://cdn.magicpatterns.com/uploads/hYZamB53u4HLxRrg3N81JZ/dada_las_imagens_de_referencia__necesito_que_hagas_una_exact.png" alt="Protocolo Premium de Calma Total" className="w-full max-w-sm rounded-2xl shadow-2xl relative z-10 border border-gold/20" animate={{
              y: [0, -15, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-183" />
            </div>

            {/* Content Column */}
            <div className="order-1 md:order-2" data-id="element-184">
              <h3 className="font-serif text-2xl text-gold mb-6 font-medium border-b border-gold/20 pb-4" data-id="element-185">
                PROTOCOLO PREMIUM DE CALMA TOTAL
              </h3>

              <motion.ul className="space-y-5" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} data-id="element-186">
                {benefits.map((benefit, index) => <motion.li key={index} className="flex items-start gap-4" variants={itemVariants} data-id="element-187">
                    <div className="bg-gold/10 p-1 rounded-full shrink-0 mt-0.5" data-id="element-188">
                      <CheckCircle2 size={20} className="text-gold" data-id="element-189" />
                    </div>
                    <span className="text-beige-light text-lg" data-id="element-190">{benefit}</span>
                  </motion.li>)}
              </motion.ul>
            </div>
          </div>

          {/* Bottom Callout */}
          <div className="mt-8 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-center gap-4 text-center sm:text-left" data-id="element-191">
            <div className="bg-gold/10 p-3 rounded-full text-gold animate-bounce" data-id="element-192">
              <ArrowRight size={24} className="rotate-90 sm:rotate-0" data-id="element-193" />
            </div>
            <div data-id="element-194">
              <p className="text-white font-medium text-lg" data-id="element-195">
                Disponible como upgrade opcional
              </p>
              <p className="text-gold/80 text-sm" data-id="element-196">
                Inmediatamente después de tu compra principal
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}